import dayjs from "dayjs";
import { CustomTypography } from "../../../components/CustomTypography/CustomTypography";
// import { getPeriodicityLabelByValue } from "../../../utils/periodicity";
import { ButtonsActionBadges } from "./ButtonsActionBadges";
import { TranslateFn } from "../../../utils/types";

/**
 * Colonnes de la liste des badges.
 *
 * Ce fichier appelait `i18n.t()` au niveau module. Un tableau litteral de
 * module est evalue UNE FOIS, a l'import du bundle - avant que l'utilisateur
 * ait touche au selecteur de langue, et jamais ensuite. Les cles etaient donc
 * bien traduites, mais figees dans la langue resolue au demarrage : changer de
 * langue ne changeait pas ces en-tetes.
 *
 * Prendre `t` en argument et appeler depuis un useMemo keye sur `t` est ce qui
 * les fait suivre un changement de langue. Meme convention que
 * containers/Sidebar/DataSideBar.ts et getColumnsListVehicle.
 */
export const getColumnsBadges = (t: TranslateFn) => [
  {
    header: t("collaborator.choiceOfType", "Choice of type"),
    field: "cardType",
  },
  {
    header: t("collaborator.choiceOfBrand", "Choice of brand"),
    field: "cardBrand",
  },
  {
    header: t("panel.vehicule.dateOfEmission", "Date of emission"),
    field: "",
    render: (data: Record<string, any>) => {
      return (
        <CustomTypography
          variant="default"
          text={
            data?.release_date
              ? dayjs(data.release_date).format("DD-MM-YYYY")
              : ""
          }
        />
      );
    },
  },
  { header: t("common.number", "Number"), field: "number" },
  {
    header: t("common.billing", "Billing"),
    field: "",
    render: (data: Record<string, any>) => {
      return (
        <CustomTypography
          variant="default"
          // text={getPeriodicityLabelByValue(data.name) ?? ""}
          text={data.name}
        />
      );
    },
  },
  {
    header: "",
    field: "",
    render: (data: Record<string, any>) => {
      return <ButtonsActionBadges badge={data as TBadge} />;
    },
  },
];
